import { query } from '@angular/animations';
import { Injectable } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore'
import { Router } from '@angular/router';
import { identity } from 'rxjs';
import { last, map } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {
  uid;
  peopleSignUpData;
  touroperatorDocId;

  constructor(
    public db: AngularFirestore,
    public auth: AuthenticationService,
    public route: Router
  ) {}

  reloadComponent(){
    let currentUrl = this.route.url;
    this.route.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.route.navigate([currentUrl]);
    });
  }

  ngOnInit(){
    this.auth.getPeopleSignInUid().then( res=> {
      this.uid = res.uid
    })
  }

  CheckDocPublish(mainColId, mainDocId, routeTo){
    return this.db.collection(mainColId).doc(mainDocId)
    .get().subscribe(doc => {
      if (doc.exists && doc.data().publish) {
        //this.documentData = doc.data();
      } else {
        // Redirect to home if "publish" field is false
        this.route.navigate([routeTo]);
      }
    }, error => {
      // Handle the error by redirecting to home
      this.route.navigate(['']);
    });
  }

  addMainCol(){}
  addSubCol(docData, mainColId, mainDocId, subColId){
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId)
    .add(docData);
  }
  updateMainDoc(formValues, mainColId, mainDocId){
    return this.db.collection(mainColId).doc(mainDocId)
    .update(formValues)
  }
  updateMainDocField(mainColId, mainDocId, keyId, valueId){
    return this.db.collection(mainColId).doc(mainDocId)
    .set({[keyId]: valueId}, { merge: true });  
  }
  setMainDoc(){}
  updateSubDoc(docData, mainColId, mainDocId, subColId, subDocId){
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId).doc(subDocId)
    .update(docData)
  }
  setSubDoc(){}
  deleteMainDoc(){}
  deleteSubDoc(mainColId, mainDocId, subColId, subDocId){
    this.db
    .collection(mainColId).doc(mainDocId)
    .collection(subColId).doc(subDocId)
    .delete()
  }

  // ################### Update Main Doc Publish & Popular Value ############################  
  updatePublishMainDoc(mainColId, mainDocId){
    return this.db.collection(mainColId).doc(mainDocId)    
      .update({
      publish: true
    });
  }
  updateUnPublishMainDoc(mainColId, mainDocId){
    return this.db.collection(mainColId).doc(mainDocId)
    .update({
      publish: false
    });
  }
  
  //Special Operations
  setMainDocaddSubCol(fileDownloadUrl, mainDocKeyId, subColKeyId, mainColId, mainDocId, subColId){   
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId)
    .add({[subColKeyId]: fileDownloadUrl})
    .then(res =>{
      this.db.collection(mainColId).doc(mainDocId)
      .set({[mainDocKeyId]: fileDownloadUrl}, { merge: true });
    })
  }
  getOwnerUid(uid, mainColId, mainDocId){
    return this.db.collection(mainColId).doc(mainDocId)
    .get().subscribe(doc => {
      doc.data().owners
    })
  }
  getMainColDocLenght(mainColId, field, uid){
    return this.db.collection(mainColId, ref=> ref
      .where(field, 'array-contains', uid)
      )    
  }
  getSubColDocLenght(mainColId, mainDocId,subColId){
    return new Promise<any>((resolve, reject) =>{
      this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId)
    .snapshotChanges()
    .subscribe(doc =>{
      const length = doc.length
      resolve(length)  
    }), error => reject(error)
    })
    
  }

  getMainCol(mainColId){
    return this.db.collection(mainColId, ref=> ref
      .orderBy('name')
      .where('publish', '==', true)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  
  getMainColOrder(mainColId, orderField){
    return this.db.collection(mainColId, ref=> ref
      .orderBy(orderField)
      .where('publish', '==', true)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getDocFieldValue(uid){
    this.db.doc(`people/${uid}`).get().subscribe(ref => {    
      if(!ref.exists){    
      }else{    
      const doc = ref.data();   
      const url = doc.profilePictureUrl  
      return url  
      }
    })    
  }
  
  getMainColOrderWhere(mainColId, orderField, key, value){
    return this.db.collection(mainColId, ref=> ref
      .orderBy(orderField)
      .where('publish', '==', true)
      .where(key, '==', value)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getMainColOrderWhereWhere(mainColId, orderField, key1, value1, key2, value2){
    return this.db.collection(mainColId, ref=> ref
      .orderBy(orderField)
      .where('publish', '==', true)
      .where(key1, '==', value1)
      .where(key2, '==', value2)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getMainColWhere(mainColId, key, value){
    return this.db.collection(mainColId, ref=> ref
      .orderBy('name')
      .where('publish', '==', true)
      .where(key, '==', value)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getMainColWhereOwner(mainColId, key, value){
    return this.db.collection(mainColId, ref=> ref
      .orderBy('name')
      .where(key, '==', value)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getMainColWhereRole(mainColId, key, value){
    return this.db.collection(mainColId, ref=> ref
      .orderBy('name')
      .where(`${key}`,'==', `${value}`)
      
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getMainDoc(mainColId, mainDocId){
    return this.db.collection(mainColId).doc(mainDocId)
    .valueChanges()
  }
  addMainDoc(formValues, mainColId){
    return this.db.collection(mainColId)
    .add(formValues)
    .then(res =>{
      this.reloadComponent();
    })
  }
  addMainBusinessDoc(formValues, mainColId, uid){
    return this.db.collection(mainColId)    
    .add({
      ...formValues,
      creator: uid,
      owners: [uid]      
    })    
    .then(res =>{
      //this.reloadComponent();
    })
  }
  getMainColWhereArrayContains(mainColId, key, value){
    return this.db.collection(mainColId, ref=> ref
      .orderBy('name')
      .where(key, 'array-contains', value)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id
        //a.payload.type      
        return { id, ...data };
      }))      
    );  
  }
  getArrayValue(mainColId, mainDocId, valueId){
    this.db.collection(mainColId).doc(mainDocId)
    .get().subscribe(doc =>{      
      const arrayField = doc.data().owners;
      const value = arrayField.includes(valueId);
      if(!value){
        this.route.navigate(['people/login']);     
      }
    })
  }

  getSubCol(mainColId, mainDocId, subColId){
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId)
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getSubColLimit(limit, mainColId, mainDocId, subColId){
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId, ref => ref
      .limit(limit)
    )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getSubColOrder(mainColId, mainDocId, subColId, orderField){
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId, ref=> ref
      .orderBy(orderField)
      )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );  
  }
  getSubDoc(mainColId, mainDocId, subColId, subDocId){
    return this.db.collection(mainColId).doc(mainDocId)
    .collection(subColId).doc(subDocId)
    .valueChanges()
  }
  getDocId(parentColId, parentDocId){
    return new Promise<any>((resolve, reject) =>{
      this.db.collection(parentColId).doc(parentDocId)
      .get().subscribe(parentData =>{
        var data = parentData.data() as any;
        resolve(data)        
      })
    })   
  }

  //CRUD - Create | Read | Update | Delete 
  //CRUD - Add | Get | Update|Set | Delete
  //############################ People ####################################//
  
  addPeople(data){
    return this.auth.addPeopleWithEmailAndPassword(data)
    .then( res=> {
        this.db.collection('people').doc(res.user.uid)
        .set({
          nameFirst: data.nameFirst,
          nameLast: data.nameLast,
          email: data.email,
          mobile: ""
        })        
    })    
    .then( res=> {
      this.route.navigate(['people/details']);
    })        
  };

  addPeopleWithGoogle(){
    return new Promise<any>((resolve, reject) => {
      this.auth.loginWithGoogle()
      .then( res=> {
        if(res.additionalUserInfo.isNewUser){
          var uid = res.user.uid;
          this.db.collection('people').doc(uid).set({
            nameFirst: res.user.displayName,        
            profilePictureUrl: res.user.photoURL,
            email: res.user.email,
            providerId: res.credential.providerId,            
            providerName: 'Google',
            phoneNumber: '',
            serviceId: 'Personal Profile',
            colId: 'people',
            docId: uid,
            dateCreated: Date.now()
          })
        }
        resolve(res);
      }, err => reject(err))
    })
    return
  };

  addPeopleWithFacebook(){
    return this.auth.loginWithFacebook()
    .then( res=> {
      if(res.additionalUserInfo.isNewUser){
        var uid = res.user.uid
        this.db.collection('people').doc(uid).set({
          name: res.user.displayName,
          pictureUrl: res.user.photoURL,
          email: res.user.email,
          providerId: res.credential.providerId,
          providerName: 'Facebook',
        })
      }      
    })    
  };

  addPeopleWithPhone(phoneNumber, uid){
    this.db.collection('people').doc(uid).set({
      phoneNumber: phoneNumber,
      nameFirst: phoneNumber,
      
    },{ merge: true });

    // return this.auth.loginWithPhone()
    // .then( res=> {
    //   if(res.additionalUserInfo.isNewUser){
    //     //var uid = res.user.uid
    //     this.db.collection('people').doc(this.uid).set({
    //       phoneNumber: phoneNumber
          
    //     })
    //   }      
    // })    
  };
  addPeopleNewDocPhone(phoneNumber, uid){
    this.db.collection('people').doc(uid).set({
      phoneNumber: phoneNumber,
      nameFirst: phoneNumber
      
    });  
  };
  addPeopleExistingDocPhone(phoneNumber, uid){
    this.db.collection('people').doc(uid).set({
      phoneNumber: phoneNumber      
    },{ merge: true });  
  };



  getPeopleDetails(uid){
    return this.db.collection('people').doc(uid).valueChanges()    
  } 

  updatePeopleDetails(formValues, uid){
    return this.db.collection('people').doc(uid).update(formValues)
  }

  deletePeople(uid){
    if(uid){
      this.db.collection('people').doc(uid).delete()
      .then(res => {
        this.auth.deletePeople();
      })
      .then( res => {
        this.route.navigate(['']);
      });
    }
  }

    //############################ Sponsor ####################################//
    getSponsorDetails(id){    
      return this.db.collection('businesses')
      .doc(id)
      .valueChanges()    
    };
  
    getSponsorLists(){    
      return this.db.collection('sponsors', ref => ref 
      .where("publish", "==", true)
      .orderBy('name') 
      .limit(5)
      )
      .snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;        
          return { id, ...data };
        }))
        
        
      );    
    };

    getSponsorProductLists(){    
      return this.db.collection('sponsorproducts', ref => ref  
      //.orderBy('name')
      .where("publish","==",true)
      //.where("popular", "==", true)
      //.where("publish", "==", true)
      //.orderBy('name') 
      //.orderBy('rank', 'desc') 
      //.limit(5)
      )
      .snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;        
          return { id, ...data };
        }))
        
        
      );    
    };

  //############################ Business ####################################//
  getBusinessDetails(id){    
    return this.db.collection('businesses')
    .doc(id)
    .valueChanges()    
  };

  getBusinessLists(catName){    
    return this.db.collection('businesses', ref => ref
    .where("category", "==", catName)    
    //.where("popular", "==", true)
    .where("publish", "==", true)
    .orderBy('name', 'desc') 
    )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))    
    );    
  };

  getBusinessListByCategories(catName){    
    return this.db.collection('businessCategories', ref => ref
    .where("name", "==", catName)
    //.where("popular", "==", true)
    //.where("publish", "==", true)
    //.orderBy('name')    
    )  
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );    
  };

  getBusinessCategoryLists(){    
    return this.db.collection('businessCategories', ref => ref
    //.where("approved", "==", true)
    .orderBy('name')
    //.limit(5)
    )
    .snapshotChanges().pipe(
      map(actions =>     
        actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id; 
        a.payload.doc.data()       
        return { id, ...data };
      }))      
    )   
  };

  getPopularBusinessLists(){    
    return this.db.collection('businesses', ref => ref
    .where("popular", "==", true)
    .where("publish", "==", true)
    .orderBy('name')    
    )   
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))
      
    )
  };
  getPopularBusinessCategoryLists(){    
    return this.db.collection('businessCategories', ref => ref
    .where("popular", "==", true)
    .where("publish", "==", true)
    .orderBy('name')    
    )  
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );    
  };

  //############################ Government ####################################//
  getGovernmentDetails(id){    
    return this.db.collection('governments')
    .doc(id)
    .valueChanges()    
  };

  getGovernmentCol(colId){    
    return this.db.collection('governments', ref => ref
    .where("category", "==", colId) 
    .where("publish", "==", true)
    .orderBy('name') 
    )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))     
    );    
  };
  getGovernmentCategoryCol(){    
    return this.db.collection('governmentCategories', ref => ref
    .orderBy('name')    
    .where('publish',"==",true))  
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))      
    );    
  };
  //############################ Tour ####################################//
  getTourPackageCol(){    
    return this.db.collection('tourpackages', ref => ref
    .orderBy('name') 
    )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))     
    );    
  };
  getTourPackageDoc(docId){    
    return this.db.collection('tourpackages')
    .doc(docId)
    .valueChanges()    
  };
  
  //############################ Handicrafts ####################################//
  getHandicraftLists(){    
    return this.db.collection('storehandicrafts', ref => ref
    .orderBy('name') 
    )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))     
    );    
  };
  getHandicraftDetails(id){    
    return this.db.collection('storehandicrafts')
    .doc(id)
    .valueChanges()    
  };
  //############################ Painting ####################################//
  getPaintingLists(){    
    return this.db.collection('storepaintings', ref => ref
    .orderBy('name') 
    )
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;        
        return { id, ...data };
      }))     
    );    
  };
  getPaintingDetails(id){    
    return this.db.collection('storepaintings')
    .doc(id)
    .valueChanges()    
  };

  
}
